// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"c149541a","288":"affb86c5","561":"7700f378","787":"44e022fc","931":"f43781c8"}[chunkId] + ".chunk.js";
};